import twinFields from '../twinFields';
import { mapState } from 'vuex';
const {
  evaluateTemplate,
  getDefinitions: getTwinFields
} = twinFields;
import get from 'lodash/get';
export default {
  name: 'TwinMapMarker',
  props: {
    twin: {
      type: Object,
      required: true
    },
    widget: {
      type: Object,
      required: true
    },
    customParameters: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  computed: {
    ...mapState('app', ['color']),
    attributes() {
      return get(this.widget, 'twinMapOptions.attributes', []);
    },
    actions() {
      return get(this.widget, 'twinMapOptions.actions', []);
    },
    twinFieldDefinitions() {
      return getTwinFields(this.$t, this.twin, {
        keyValueAtributes: this.attributes.filter(attribute => attribute.property.startsWith('twin.key_value__')).map(attribute => attribute.property.replace('twin.key_value__', ''))
      });
    },
    markerRules() {
      return get(this.widget, 'twinMapOptions.rules', []);
    },
    markerColor() {
      const defaultColor = this.color;
      if (this.markerRules.length === 0) {
        return defaultColor;
      }
      const firstApplicableRule = this.markerRules.find(rule => {
        const ruleField = get(rule, 'field', '');
        if (!ruleField) {
          return false;
        }
        const expectedValue = get(rule, 'value', '');
        const fieldDefinition = this.twinFieldDefinitions[ruleField];
        let actualValue = '';
        if (fieldDefinition) {
          actualValue = get(this.twin, fieldDefinition.key, '');
        }
        if (ruleField.startsWith('state.')) {
          const stateKey = ruleField.replace('state.', '');
          const histories = get(this.twin, `_states['${stateKey}'].history.histories`, []);
          const sortedHistories = [...histories].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
          const latestHistoryItem = sortedHistories[0];
          actualValue = get(latestHistoryItem, 'value', '');
        }
        if (typeof actualValue === 'number') {
          actualValue = actualValue.toString();
        }
        switch (rule.operator) {
          case 'eq':
            // eslint-disable-next-line eqeqeq
            return actualValue == expectedValue;
          case 'neq':
            // eslint-disable-next-line eqeqeq
            return actualValue != expectedValue;
          case 'gt':
            return actualValue > expectedValue;
          case 'gte':
            return actualValue >= expectedValue;
          case 'lt':
            return actualValue < expectedValue;
          case 'lte':
            return actualValue <= expectedValue;
          default:
            return false;
        }
      });
      return firstApplicableRule ? firstApplicableRule.color : defaultColor;
    }
  },
  methods: {
    get,
    template(template) {
      return evaluateTemplate({
        twin: this.twin,
        customParameters: this.customParameters,
        template,
        i18n_t: this.$t
      });
    },
    getAttributeLabel(attribute) {
      if (attribute.label) {
        return attribute.label;
      }
      if (attribute.property.startsWith('state.')) {
        return attribute.property.replace('state.', '');
      }
      const definition = get(this.twinFieldDefinitions, `['${attribute.property}']`);
      if (!definition) {
        return attribute.property;
      }
      return definition.defaultLabel;
    },
    getAttributeValue(attribute) {
      let value;
      if (attribute.property.startsWith('state.')) {
        const stateKey = attribute.property.replace('state.', '');
        const histories = get(this.twin, `_states['${stateKey}'].history.histories`, []);
        const sortedHistories = [...histories].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        const latestHistoryItem = sortedHistories[0];
        value = get(latestHistoryItem, 'value', '');
      } else {
        const definition = get(this.twinFieldDefinitions, `['${attribute.property}']`);
        if (!definition) {
          return attribute.property;
        }
        const propertyPath = definition.key;
        value = get(this.twin, propertyPath);
      }
      return value || this.$t('Dashboards.components.twinMap.popup.attributes.noValue');
    },
    onActionClick(action, twin) {
      this.$emit('click:action', {
        action,
        twin
      });
    }
  }
};